import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import 'pwa-mmt-ui-header/ssr/header.css';
import BizHeaderUI from 'corp-common-ui/bizHeader';

import { getHeaderOptions, getProfile, updateHeaderOptions, nextFeatureDesc, skipFeatureDesc } from 'reduxStore/actions/bizHeaderActions';
import { getCookie, redirectTologinWithUrl, saveServerLogs, isDashBoard } from '../UtilityComponents/Util';
import { updatePopup } from 'reduxStore/actions/popupActions';
import { ADMIN_REQ_POPUP, urlMap } from './config';
import { APPLICATION_CONSTANTS, PATHS, MYBIZ_LOGO_IMAGES, MYBIZ_DEFAULT_LOGOS } from 'AppConstants';
import { getAbExperiment } from 'apis/commonApis';
import { logOmniClick } from '../logging/omnitureService';
import FeatureInfo from 'common/FeatureInfo/FeatureInfo';
import ProfileMenu from './components/ProfileMenu/ProfileMenu';

const onLogout = () => typeof window !== 'undefined' && window.location.reload();

const Header = (props) => {
	const {
		mmtHeader,
		blockClick,
		showHeader = true,
		showNav = true,
		showBreadCrumb,
		reInitializeHeader,
		onLoginFlowComplete,
		helpInHeader,
		showHeaderOptionsBar = true
	} = props;

	const dispatch = useDispatch();

	const profileData = useSelector((state) => state.bizHeader.profileData);
	const profileApiFailed = useSelector((state) => state.bizHeader.profileApiFailed);
	const profileApiSucces = useSelector((state) => state.bizHeader.profileApiSucces);
	const profileApiCalling = useSelector((state) => state.bizHeader.profileApiCalling);
	const headerApiCall = useSelector((state) => state.bizHeader.headerApiCall);
	const feature = useSelector((state) => state.bizHeader.feature);
	const headerOptions = useSelector((state) => state.bizHeader.headerOptions);
	const { isAdmin, isLoggedIn } = headerOptions;

	useEffect(() => {
		if (profileApiFailed || profileApiSucces) {
			if (isLoggedIn && !profileData) {
				redirectTologinWithUrl();
				saveServerLogs('login check failed invalid mmtauth no profile data found', 'error', window.location.pathname);
			}
			if (isAdmin && !profileData.isAdmin && false) { // need to handle superadmin redirection
				dispatch(updatePopup({
					showPop: true,
					popData: {
						...ADMIN_REQ_POPUP,
						redirectionUrl: PATHS.MMT_BIZ_PROFILE_URL
					}
				}));
			}
		}
	}, [profileApiFailed, profileApiSucces, profileData, isAdmin, isLoggedIn, dispatch]);

	useEffect(() => {
		headerApiCall && !mmtHeader && dispatch(getHeaderOptions());
	}, [isLoggedIn, headerApiCall, mmtHeader, dispatch]);

	useEffect(() => {
		const mmtauth = getCookie('mmt-auth');
		if (mmtauth && isLoggedIn && profileApiCalling) {
			dispatch(getProfile());
		}
	}, [isLoggedIn, profileApiCalling, dispatch]);

	useEffect(() => {
		const fetchAbData = async () => {
			if (!profileApiCalling) {
				let diceEnabled = true;
				let typeEnabledOrg = false;
				let hrmsEnabled = false;
				const abPlatformApi = APPLICATION_CONSTANTS.MYBIZ_CORE;
				try {
					const res = await getAbExperiment(abPlatformApi);
					diceEnabled = typeof res?.diceEnabled === 'undefined' ? true : res.diceEnabled;
					typeEnabledOrg = typeof res?.vip_enabled_org === 'undefined' ? false : res.vip_enabled_org;
					hrmsEnabled = typeof res?.['mmt.desktop.mybiz_core.default.default.default.hrms_enable'] === 'undefined' ? false : res['mmt.desktop.mybiz_core.default.default.default.hrms_enable'];
				} catch (error) { } finally {
					dispatch(updateHeaderOptions({ diceEnabled, typeEnabledOrg, hrmsEnabled }));
				}
			}
		};
		fetchAbData();
	}, [profileApiCalling, dispatch]);

	const onLoginCompleteAction = useCallback(() => {
		if (!onLoginFlowComplete) {
			window.location.reload();
		} else {
			onLoginFlowComplete();
		}
	}, [onLoginFlowComplete]);

	const onNextFeature = useCallback((payload, isClose) => {
		dispatch(nextFeatureDesc(payload, isClose));
	}, [dispatch]);

	const onSkipFeature = useCallback(() => {
		dispatch(skipFeatureDesc());
	}, [dispatch]);

	const onAdminRequired = useCallback(() => {
		dispatch(updatePopup({
			showPop: true,
			popData: {
				...APPLICATION_CONSTANTS.ADMIN_REQUIRED_POP,
				apiStatus: 'ERR_DEFAULT',
				isFooter: true
			}
		}));
	}, [dispatch]);

	const onTrack = useCallback((trackVal, extra = {}) => {
		logOmniClick(trackVal, {
			prop54: trackVal + '|v2|corporate',
			eVar34: extra.email
		});
	}, []);

	return (
		<BizHeaderUI
			{...props}
			mmtHeader={mmtHeader}
			stickyHeader={mmtHeader}
			showHeader={showHeader}
			showNav={showNav}
			blockClick={blockClick}
			showBreadCrumb={showBreadCrumb}
			reInitializeHeader={reInitializeHeader}
			helpInHeader={helpInHeader}
			showHeaderOptionsBar={showHeaderOptionsBar}
			onLoginFlowComplete={onLoginCompleteAction}
			onLogout={onLogout}
			headerOptions={headerOptions}
			profileData={profileData || { loggedOut: true }}
			feature={feature}
			onNextFeature={onNextFeature}
			onSkipFeature={onSkipFeature}
			onAdminRequired={onAdminRequired}
			onTrack={onTrack}
			urlMap={urlMap}
			paths={{
				dashboard: PATHS.DASHBOARD,
				myBizHome: PATHS.MMT_MYBIZ,
				loginUrl: PATHS.MYBIZ_LOGIN_EXPIRE_URL
			}}
			logoProps={MYBIZ_LOGO_IMAGES.LOGO || MYBIZ_DEFAULT_LOGOS.LOGO}
			profileMenu={<ProfileMenu />}
			FeatureInfoComponent={FeatureInfo}
			newlyLaunchedText={APPLICATION_CONSTANTS.NEWLY_LAUNCHED}
			enableHeaderCoachmark={isDashBoard()}
		/>
	);
};

export default Header;
